/**
 * Created by: cparaschiv
 * Date: 26.03.2013, 16:43
 */

TS.ns('TS.viewModel', 'TS.util');